import { createSlice } from "@reduxjs/toolkit";
import { fetchReferralpaymentsItems } from "./ReferralpaymentsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const referralpaymentsSlice = createSlice({
  name: "referralpayments",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchReferralpaymentsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralpaymentsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchReferralpaymentsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default referralpaymentsSlice.reducer;